import type { StudyApiId } from '@/model/Study.model';
import {
  BenchlingBackfillApiId,
  BenchlingBackfillEntityType,
  BenchlingBackfillEventApiId,
  BenchlingSyncEventApiId,
} from '@/model/BenchlingBackfill.model.ts';

export enum SyncEntityContext {
  BACKFILL_EVENTS = 'backfill-events',
  SYNC_EVENTS = 'sync-events',
  STUDY_SYNC_EVENTS = 'study-sync-events',
}

export interface BackfillEventsSyncEntityRequestProps {
  context: SyncEntityContext.BACKFILL_EVENTS;
  backfillApiId: BenchlingBackfillApiId;
  backfillEventApiId: BenchlingBackfillEventApiId;
}

export interface SyncEventsSyncEntityRequestProps {
  context: SyncEntityContext.SYNC_EVENTS;
  syncEventApiId: BenchlingSyncEventApiId;
}

export interface StudySyncEventsSyncEntityRequestProps {
  context: SyncEntityContext.STUDY_SYNC_EVENTS;
  studyApiId: StudyApiId;
  syncEventApiId: BenchlingSyncEventApiId;
}

export type SyncEntityRequestProps =
  | BackfillEventsSyncEntityRequestProps
  | SyncEventsSyncEntityRequestProps
  | StudySyncEventsSyncEntityRequestProps;

export interface SyncEntityDetailsProps {
  syncEntityRequestProps: SyncEntityRequestProps;
  entityType: BenchlingBackfillEntityType;
  closeModal: () => void;
}
